import { GeoJSON, LatLng } from 'leaflet';
import { checkIncluding } from 'views/components/Video/MapComponent/utils/checkIncluding';

interface IStop {
  geo: string;
  id: number;
  name: string;
}

export interface IRoute {
  color: string | null;
  gis_muid: number;
  route_id: number;
  stops: IStop[];
  trajectory: string;
}

export interface IParsedRoute {
  position: Array<LatLng>;
  id: number;
  color: string | null;
}

export interface IParsedStop {
  position: LatLng;
  id: number;
  route_id: number;
  name: string;
}

export interface IMinimizedStop {
  position: LatLng;
  id: number;
  route_id: number;
  name: string;
}

export const parseRoutes = (
  routes: Array<IRoute>
): {
  routes: Array<IParsedRoute>;
  stops: Array<IParsedStop>;
  minimizedStop: Array<IMinimizedStop>;
  initialRoutes: IRoute[];
} => ({
  initialRoutes: routes,
  routes: routes
    .filter(({ trajectory }) => trajectory && !trajectory.includes('MULTILINESTRING'))
    .map((route) => ({
      position: route.trajectory
        .slice(11, -1)
        .split(',')
        .map((route) => route.split(' ').map((route) => parseFloat(route)))
        .map((routeCoords) =>
          GeoJSON.coordsToLatLng([routeCoords[0], routeCoords[1]])
        ),
      id: route.route_id,
      color: route.color,
    })),
  stops: routes.reduce(
    (stops: Array<IParsedStop>, route: IRoute) => [
      ...stops,
      ...route.stops
        .filter(({ geo }) => geo)
        .map((stop) => ({
          position: GeoJSON.coordsToLatLng(
            stop.geo
              .slice(6, -1)
              .split(' ')
              .map((coord) => parseFloat(coord)) as [number, number]
          ),
          id: stop.id,
          route_id: route.route_id,
          name: stop.name,
        })),
    ],
    []
  ),
  minimizedStop: routes
    .reduce((stops: Array<IParsedStop>, route: IRoute) => {
      const result = [...stops];
      if (route.stops[0].geo) {
        result.push({
          position: GeoJSON.coordsToLatLng(
            route.stops[0].geo
              .slice(6, -1)
              .split(' ', 2)
              .map((coord) => parseFloat(coord)) as [number, number]
          ),
          id: route.stops[0].id,
          route_id: route.route_id,
          name: route.stops[0].name,
        });
      }
      if (route.stops[route.stops.length - 1].geo) {
        result.push({
          position: GeoJSON.coordsToLatLng(
            route.stops[route.stops.length - 1].geo
              .slice(6, -1)
              .split(' ', 2)
              .map((coord) => parseFloat(coord)) as [number, number]
          ),
          id: route.stops[route.stops.length - 1].id,
          route_id: route.route_id,
          name: route.stops[0].name,
        });
      }
      return result;
    }, [])
    .reduce(
      (stops, stop) =>
        checkIncluding(stop.position, stops) ? stops : [...stops, stop],
      [] as Array<IMinimizedStop>
    ),
});
